import { render, staticRenderFns } from "./_q.vue?vue&type=template&id=282728c6&scoped=true&"
import script from "./_q.vue?vue&type=script&lang=js&"
export * from "./_q.vue?vue&type=script&lang=js&"
import style0 from "./_q.vue?vue&type=style&index=0&id=282728c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282728c6",
  null
  
)

export default component.exports